import React from 'react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const SignatureCard = () => {
  return (
    <div
      style={{
        background: COLORS.backgroundSecondary,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.card,
        padding: '24px 16px 14px 16px',
        marginTop: '6mm',
        position: 'relative',
        textAlign: 'center'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -10%)',
          width: '85%',
          borderTop: `1px solid ${COLORS.textPrimary}`,
          opacity: 0.4
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          fontSize: '11px',
          fontWeight: 700,
          color: COLORS.textPrimary,
          letterSpacing: '2px',
          background: COLORS.backgroundSecondary,
          padding: '0 8px',
          display: 'inline-block'
        }}
      >
        ASSINATURA / APROVAÇÃO
      </div>
    </div>
  );
};

export default SignatureCard;
